export const SET_MATRICES = 'SET_MATRICES';
export const SELECT_MATRIX = 'SELECT_MATRIX';
export const MATRIX_LOADED = 'MATRIX_LOADED';
export const MATRIX_COLLAPSE_TOGGLE = 'MATRIX_COLLAPSE_TOGGLE';

export const setMatrices = matrices => {
    return {
        type: SET_MATRICES,
        matrices
    }
};

export const selectMatrix = city => {
    return {
        type: SELECT_MATRIX,
        city
    }
};

export const matrixLoaded = () => {
    return {
        type: MATRIX_LOADED
    }
};

export const toggleMatrixCollapse = () => {
    return {
        type: MATRIX_COLLAPSE_TOGGLE
    }
};



// WEBPACK FOOTER //
// ./src/actions/MatrixActions.js